import mergeObj from '../extraUtil/mergeTwoObj';

let chart = {
    "animation":"0",
    "caption":"Shipment Count Per Destination States",
    "captionFontColor":"#bebebe",
    "showLabels": "1",
    "showborder": "1",
    "showcanvasborder": "0",
    "showhovereffect": "1",
    "bordercolor": "#717170",
    "borderthickness": "1",
    "nullEntityAlpha": "0",
    "showlegend":"0",
    "useHoverColor":"1",
    "hoverColor":"#589188",
    "updateAnimDuration":"1"
}

export default function dataSourceGenerator(rawData, timeSelectorValue, theme) {
    chart = mergeObj(chart, theme);
    let dataSource = {},
        states = [],
        data = [],
        statesObj = {},
        statesObjCount = {};
    for (let i = 0; i < rawData.length; i++) {
        let state = rawData[i]['destinationState'];
        if (!states.includes(state)) {
            states.push(state);
        }
    }
    for (let i = 0; i < states.length; i++) {
        statesObj[states[i]] = 0;
        statesObjCount[states[i]] = 0;
    }
    for (let i = 0; i < rawData.length; i++) {
        let state = rawData[i]['destinationState'];
        (statesObj[state] = statesObj[state] + 1);
        statesObjCount[state] ++;
    }
    for (let index = 0; index < states.length; index++) {
        let dataObj = {
            "id": states[index],
            "value": statesObj[states[index]]
        }
        data.push(dataObj);
    }
    dataSource = {
        chart: chart,
        data: data,
        colorrange: {
            "gradient": "0",
            "color": [
                {
                    "minvalue": "0",
                    "maxvalue": "5",
                    "code": "#64A38C",
                    "alpha":"10"
                },
                {
                    "minvalue": "6",
                    "maxvalue": "20",
                    "code": "#64A38C",
                    "alpha":"30"
                },
                {
                    "minvalue": "21",
                    "maxvalue": "50",
                    "code": "#64A38C",
                    "alpha":"60"
                },
                {
                    "minvalue": "51",
                    "maxvalue": "450",
                    "code": "#64A38C",
                    "alpha":"100"
                }
            ]
        }
    }
    return dataSource
}


// WEBPACK FOOTER //
// ./src/util/dataSourceGenerators/usaMapGenerator.js